import { connect } from "react-redux";
import {
  Creators,
  getQueueUsers,
  getIsLoading,
  getSelectedUserInQueue
} from "../../reducer";
import Queue from "./Queue";

export default connect(
  (state, ownProps) => ({
    queueUsers: getQueueUsers(state, ownProps.rangeLocation),
    selectedUserInQueue: getSelectedUserInQueue(state),
    isLoading: getIsLoading(state, ownProps.rangeLocation),
    location: state.login.location
  }),
  dispatch => ({
    onUpdateQueueOrder: (location, queueUsers) =>
      dispatch(Creators.updateQueueOrder(location, queueUsers)),
    onGroupRegistration: (location, selectedUserInQueue) =>
      dispatch(Creators.groupRegistration(location, selectedUserInQueue)),
    onUpdateQuickAddDrawerVisibility: (visibility) =>
      dispatch(Creators.updateQuickAddDrawerVisibility(visibility))
  })
)(Queue);



// WEBPACK FOOTER //
// ./src/staff/components/Queue/index.js